<template>
  <div style="padding: 16px; cursor: pointer" >
    <div v-if="!state">
      <ElIcons name="Fold" size="20" />
    </div>
    <div v-else>
      <ElIcons name="Expand" size="20" />
    </div>
  </div>
</template>

<script>
export default {
name: "CollapseBtn",
  props: {
    state: {
      type: Boolean,
      default: false,
    }
  }
}
</script>

<style scoped>

</style>
